import { getEventScope } from "../../core/event-scope/event-scope";
import { enableModalTitlebarDrag } from "../../util/modal-titlebar-drag";
import type { ModalSearchBase } from "./modal-search-base-handler";

export interface ModalSearchListenerParams {
    rootEl: Document | HTMLElement;
    scopeKey: string;
    overlayEl: HTMLElement;
    modalEl: HTMLElement;
    closeBtnEl?: HTMLElement | null;
    filterInputEl?: HTMLInputElement | null;
    actionRootEls?: HTMLElement[];
    base: ModalSearchBase;
}

export class ModalSearchListener {
    public static setup(params: ModalSearchListenerParams): void {
        const {
            rootEl,
            scopeKey,
            overlayEl,
            modalEl,
            closeBtnEl = null,
            filterInputEl = null,
            actionRootEls = [],
            base,
        } = params;

        const scope = getEventScope(rootEl, scopeKey);

        scope.once("modal-bind", () => {
            overlayEl.addEventListener("click", (event) => {
                event.stopPropagation();
                base.handleOverlayClick(event);
            });

            modalEl.addEventListener("click", (event) => {
                event.stopPropagation();
            });

            modalEl.addEventListener("click", (event) => {
                if (event instanceof MouseEvent) {
                    base.handleActionClick(event);
                }
            });

            if (closeBtnEl) {
                closeBtnEl.addEventListener("click", (event) => base.handleCloseClick(event));
            }

            if (filterInputEl) {
                filterInputEl.addEventListener("input", (event) => {
                    if (event instanceof InputEvent) {
                        base.handleFilterInput(event);
                    }
                });
            }

            enableModalTitlebarDrag(modalEl, { isEnabled: () => base.isOpen });

            actionRootEls.forEach((root) => {
                if (!(root instanceof HTMLElement)) return;
                root.addEventListener("click", (event) => base.handleActionClick(event));
            });

            rootEl.addEventListener(
                "keydown",
                (event) => {
                    if (!(event instanceof KeyboardEvent)) return;
                    if (!base.isOpen) return;

                    if (event.key === "Escape") {
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        base.close();
                        return;
                    }

                    if (event.key !== "Enter") return;

                    const target = event.target instanceof HTMLElement ? event.target : null;
                    const tag = target ? target.tagName : "";
                    if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return;

                    event.preventDefault();
                    event.stopPropagation();
                    base.close();
                },
                { capture: true },
            );
        });
    }
}
